import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

// Spiegazione al passaggio del mouse per i pulsanti del fascicolo.
export const Hint = ({ text, children }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild><span className="inline-flex">{children}</span></TooltipTrigger>
      <TooltipContent className="max-w-xs bg-forest text-xs leading-snug text-white">{text}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
